@if (!isQuoteOnly()) {
    <div class="ft-goal-options">
        @if (!!story()) {
            <div class="ft-option generate-leads" (click)="inviteToGuestPage()">
                <div class="ft-option-header">
                    <div class="ft-v-align-container">
                        <div class="ft-v-align-content">
                            <div class="ft-supertitle">Get warm leads through</div>
                            <div class="ft-option-title">Story Explorer</div>
                        </div>
                    </div>
                </div>
                <div class="ft-option-body ft-text-minus-1">
                    <p>Inspire your audience to take interest in a future stay while they check out this and other stories.</p>
                </div>
            </div>
        }
        @for (contest of contests(); track contest) {
            @if ((contest.isActive | parse:'bool') && !(contest.isClosed | parse:'bool') && (contest.endDate | daysUntilDate) >= 1) {
                <div class="ft-option generate-storytellers"
                     (click)="onInviteToContest(contest)">
                    <div class="ft-option-header">
                        <div class="ft-v-align-container">
                            <div class="ft-v-align-content">
                                <div class="ft-supertitle">Invite people to join</div>
                                <div class="contest-title">{{ contest.name }}</div>
                                <div class="contest-date-range">{{ contest.startDate | dateRange:contest.endDate }}</div>
                            </div>
                        </div>
                    </div>
                    <div class="ft-option-body ft-text-minus-1">
                        <p>Discover new storytellers and engage friends & family with their best travel moments.</p>
                    </div>
                </div>
            }
        }
    </div>
}
@if (isQuoteOnly()) {
    <div class="ft-goal-options">
        <div class="ft-option generate-leads1" (click)="onInviteToWebsite()">
            <div class="ft-option-header">
                <div class="ft-v-align-container">
                    <div class="ft-v-align-content">
                        <div class="ft-supertitle">Attract visitors to</div>
                        <div class="ft-option-title">Your website</div>
                    </div>
                </div>
            </div>
            <div class="ft-option-body ft-text-minus-1">
                <p>Show your audience what your recent travelers have to say about their experience and provide a link to check out your website.</p>
            </div>
        </div>
    </div>
}
